import * as XLSX from 'xlsx';

const toSafeNumber = (value) => Number(value || 0);

const formatHours = (value) => `${toSafeNumber(value).toFixed(2)} h`;

export const exportDashboardTicketsExcel = ({ dashboard, filters }) => {
    const summaryRows = [
        ['Métrica', 'Valor'],
        ['Tickets totales', toSafeNumber(dashboard?.summary?.totalTickets)],
        ['Tickets abiertos', toSafeNumber(dashboard?.summary?.openTickets)],
        ['Tickets resueltos', toSafeNumber(dashboard?.summary?.resolvedTickets)],
        ['Vencidos abiertos', toSafeNumber(dashboard?.summary?.overdueOpenTickets)],
        ['Resueltos fuera de SLA', toSafeNumber(dashboard?.summary?.breachedResolvedTickets)],
        ['Tiempo prom. primera respuesta', formatHours(dashboard?.summary?.avgFirstResponseHours)],
        ['Tiempo prom. resolución', formatHours(dashboard?.summary?.avgResolutionHours)],
    ];

    const statusRows = [['Estatus', 'Tickets'], ...(dashboard?.tickets?.byStatus || []).map((item) => [item.label || item.key, toSafeNumber(item.total)])];
    const priorityRows = [['Prioridad', 'Tickets'], ...(dashboard?.tickets?.byPriority || []).map((item) => [item.label || item.key, toSafeNumber(item.total)])];
    const typeRows = [['Tipo', 'Tickets'], ...(dashboard?.tickets?.byType || []).map((item) => [item.label || item.key, toSafeNumber(item.total)])];
    const sourceRows = [['Origen', 'Tickets'], ...(dashboard?.tickets?.bySource || []).map((item) => [item.label || item.key, toSafeNumber(item.total)])];
    const createdTrendRows = [['Fecha', 'Creados'], ...(dashboard?.tickets?.createdTrend || []).map((item) => [item.date, toSafeNumber(item.total)])];
    const resolvedTrendRows = [['Fecha', 'Resueltos'], ...(dashboard?.tickets?.resolvedTrend || []).map((item) => [item.date, toSafeNumber(item.total)])];
    const agingRows = [['Antigüedad', 'Abiertos'], ...(dashboard?.tickets?.openAging || []).map((item) => [item.label || item.key, toSafeNumber(item.total)])];
    const assigneesRows = [['Responsable', 'Tickets'], ...(dashboard?.tickets?.topAssignees || []).map((item) => [item.name || '-', toSafeNumber(item.total)])];

    const wb = XLSX.utils.book_new();

    const summaryWs = XLSX.utils.aoa_to_sheet(summaryRows);
    const filtersWs = XLSX.utils.aoa_to_sheet([
        ['Filtro', 'Valor'],
        ['Rango rápido (días)', filters?.days || ''],
        ['Fecha desde', filters?.dateFrom || ''],
        ['Fecha hasta', filters?.dateTo || ''],
        ['Estatus', filters?.status || 'Todos'],
        ['Prioridad', filters?.priority || 'Todas'],
        ['Tipo', filters?.type || 'Todos'],
        ['Origen', filters?.source || 'Todos'],
        ['Responsable', filters?.assigneeLabel || 'Todos'],
        ['SLA', filters?.slaModeLabel || 'Todos'],
    ]);

    XLSX.utils.book_append_sheet(wb, summaryWs, 'Resumen');
    XLSX.utils.book_append_sheet(wb, filtersWs, 'Filtros');
    XLSX.utils.book_append_sheet(wb, XLSX.utils.aoa_to_sheet(statusRows), 'Estatus');
    XLSX.utils.book_append_sheet(wb, XLSX.utils.aoa_to_sheet(priorityRows), 'Prioridades');
    XLSX.utils.book_append_sheet(wb, XLSX.utils.aoa_to_sheet(typeRows), 'Tipos');
    XLSX.utils.book_append_sheet(wb, XLSX.utils.aoa_to_sheet(sourceRows), 'Orígenes');
    XLSX.utils.book_append_sheet(wb, XLSX.utils.aoa_to_sheet(createdTrendRows), 'Tendencia Creados');
    XLSX.utils.book_append_sheet(wb, XLSX.utils.aoa_to_sheet(resolvedTrendRows), 'Tendencia Resueltos');
    XLSX.utils.book_append_sheet(wb, XLSX.utils.aoa_to_sheet(agingRows), 'Antigüedad');
    XLSX.utils.book_append_sheet(wb, XLSX.utils.aoa_to_sheet(assigneesRows), 'Responsables');

    XLSX.writeFile(wb, `dashboard-tickets-${new Date().toISOString().slice(0, 10)}.xlsx`);
};

export const exportDashboardTicketsPdf = ({ dashboard, filters }) => {
    const printableWindow = window.open('', '_blank', 'width=1024,height=768');
    if (!printableWindow) {
        return;
    }

    const statusRows = (dashboard?.tickets?.byStatus || [])
        .map((item) => `<tr><td>${item.label || item.key}</td><td style="text-align:right;">${toSafeNumber(item.total)}</td></tr>`)
        .join('');

    const summary = dashboard?.summary || {};

    printableWindow.document.write(`
        <html>
            <head>
                <title>Dashboard de Tickets</title>
                <style>
                    body { font-family: Arial, sans-serif; margin: 24px; color: #111827; }
                    h1 { margin: 0 0 4px 0; font-size: 20px; }
                    p { margin: 0 0 12px 0; color: #6b7280; font-size: 12px; }
                    .grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 8px; margin-bottom: 16px; }
                    .card { border: 1px solid #e5e7eb; border-radius: 8px; padding: 10px; }
                    .label { font-size: 11px; color: #6b7280; }
                    .value { font-size: 18px; font-weight: bold; margin-top: 4px; }
                    table { width: 100%; border-collapse: collapse; margin-top: 12px; }
                    th, td { border: 1px solid #e5e7eb; padding: 8px; font-size: 12px; }
                    th { background: #f3f4f6; text-align: left; }
                    .filters { margin-top: 12px; font-size: 11px; color: #4b5563; }
                </style>
            </head>
            <body>
                <h1>Dashboard de Tickets</h1>
                <p>Reporte generado automáticamente (${new Date().toLocaleString('es-MX')})</p>

                <div class="grid">
                    <div class="card"><div class="label">Tickets totales</div><div class="value">${toSafeNumber(summary.totalTickets)}</div></div>
                    <div class="card"><div class="label">Abiertos</div><div class="value">${toSafeNumber(summary.openTickets)}</div></div>
                    <div class="card"><div class="label">Resueltos</div><div class="value">${toSafeNumber(summary.resolvedTickets)}</div></div>
                    <div class="card"><div class="label">Vencidos abiertos</div><div class="value">${toSafeNumber(summary.overdueOpenTickets)}</div></div>
                    <div class="card"><div class="label">Fuera de SLA</div><div class="value">${toSafeNumber(summary.breachedResolvedTickets)}</div></div>
                    <div class="card"><div class="label">Prom. resolución</div><div class="value">${formatHours(summary.avgResolutionHours)}</div></div>
                </div>

                <h3>Distribución por estatus</h3>
                <table>
                    <thead><tr><th>Estatus</th><th>Tickets</th></tr></thead>
                    <tbody>${statusRows}</tbody>
                </table>

                <div class="filters">
                    <strong>Filtros:</strong>
                    rango=${filters?.days || ''}, desde=${filters?.dateFrom || '-'}, hasta=${filters?.dateTo || '-'},
                    estatus=${filters?.status || 'Todos'}, prioridad=${filters?.priority || 'Todas'}, tipo=${filters?.type || 'Todos'},
                    origen=${filters?.source || 'Todos'}, responsable=${filters?.assigneeLabel || 'Todos'}, SLA=${filters?.slaModeLabel || 'Todos'}
                </div>
            </body>
        </html>
    `);

    printableWindow.document.close();
    printableWindow.focus();
    printableWindow.print();
};
